import {
    TableCell as MuiTableCell,
    TableHead,
    TableFooter as TableFoot,
    styled,
    TableRow as MuiTableRow,
    TableSortLabel as MuiTableSortLabel,
    TableSortLabelProps,
    Table as MuiTable
} from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

export const TableHeader = styled(TableHead)`
    background-color: #f9fafb;
    border-top: 1px solid var(--Gray-300, #d0d5dd); //TODO: move color to theme
    height: 32px;
`;

export const TableFooter = styled(TableFoot)`
    background-color: #f2f4f7;
    border-top: 1px solid var(--Gray-300, #d0d5dd); //TODO: move color to theme
    height: 32px;
    font-weight: 600;
`;

export const TableCell = styled(MuiTableCell, {
    shouldForwardProp: (prop) => prop !== 'disabled'
})<{
    disabled?: boolean;
}>`
    padding: 0px 8px 0px 24px;
    height: 40px;
    align-items: center;

    font-weight: 500;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 0;
    vertical-align: middle;
    text-decoration-style: solid;
    text-decoration-thickness: 0;
    text-decoration-skip-ink: auto;

    ${({ disabled }) =>
        disabled &&
        `
        cursor: not-allowed;
        opacity: 0.5;
    `}
`;

export const TableCellSetting = styled(MuiTableCell)`
    padding: 6px 12px 6px 24px;
    height: 40px;
`;

export const TableCellNoBorder = styled(TableCell)`
    border-bottom: none;
    padding: 12px, 8px, 12px, 8px;
`;

export const TableHeaderCell = styled(MuiTableCell)`
    padding: 0px 8px 0px 24px;
    height: 32px;
    font-weight: 600;
`;

export const TableHeaderCellWithCheckbox = styled(MuiTableCell)`
    padding: 0px 8px 0px 24px;
    height: 32px;
    font-weight: 600;
`;

export const TableFooterCell = styled(MuiTableCell)`
    padding: 0px 8px 0px 24px;
    height: 32px;
    font-weight: 600;
`;

export const TableHeaderCellFirstCell = styled(TableHeaderCell)`
    padding-left: 20px;
`;

export const TableCellFirstCell = styled(TableCell)`
    padding-left: 20px;
`;

export const TableCellNoPadding = styled(MuiTableCell)`
    & {
        padding: 0px;
    }
`;

export const TableIconButtonCell = styled(MuiTableCell)`
    & {
        width: 8px;
        text-align: center;
        padding: 0px 0px 0px 8px;
    }
`;

export const _MuiTableSortLabel = (
    props: TableSortLabelProps & { align?: 'left' | 'right' | 'center' }
) => {
    const { align: _align = 'left', sx, ...restProps } = props;

    return (
        <MuiTableSortLabel
            style={{ width: '100%' }}
            IconComponent={KeyboardArrowDownIcon}
            {...restProps}
            sx={sx}
        />
    );
};

export const TableSortLabel = styled(_MuiTableSortLabel, {
    shouldForwardProp: (prop) => prop !== 'align'
})<{ align?: 'left' | 'right' | 'center' }>`
    padding: 0px 0px 0px 0px;
    height: 32px;
    font-weight: 600;
    width: 100%;
    white-space: nowrap;
    text-overflow: ellipsis;

    ${({ align }) =>
        align === 'right'
            ? `
        flex-direction: row-reverse;
        justify-content: flex-start;
        & svg {
            margin-left: 0px;
            margin-right: 16px;
            opacity: 1;
        }
        & .MuiTableSortLabel-icon {
            opacity: 1;
            margin-left: 0px;
            margin-right: 16px;
        }
    `
            : `
        flex-direction: row;
        justify-content: space-between;
        & svg {
            margin-left: auto;
            margin-right: 0px;
            opacity: 1;
        }
        & .MuiTableSortLabel-icon {
            opacity: 1;
            margin-left: auto;
        }
    `}
`;

export const TableRow = styled(MuiTableRow, {
    shouldForwardProp: (prop) =>
        prop !== 'hoverEffect' && prop !== 'disabled' && prop !== 'warning'
})<{
    hoverEffect?: boolean;
    disabled?: boolean;
    warning?: boolean;
}>`
    ${({ hoverEffect }) =>
        hoverEffect &&
        `
        &:hover {
            background-color: #EFF8FF;
        }
    `}
    ${({ disabled }) =>
        disabled &&
        `
        opacity: 0.5;
        background-color: #f9fafb;

        &:hover {
            background-color: #f9fafb;
        }
    `}
    ${({ warning, theme }) =>
        warning &&
        `
        background-color: ${theme.palette.warning.light};
    `}
`;

export const Table = styled(MuiTable)`
    border: 1px solid #d0d5dd;
`;
